"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHoveredIconButtonStyles = void 0;
// inspired by https://github.com/mui-org/material-ui/blob/next/packages/material-ui/src/TableSortLabel/TableSortLabel.js
var styles_1 = require("@material-ui/core/styles");
exports.useHoveredIconButtonStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        cursor: 'pointer',
        display: 'inline-flex',
        justifyContent: 'flex-start',
        flexDirection: 'inherit',
        alignItems: 'center',
        '&:focus': {
            color: theme.palette.text.secondary,
        },
        '&:hover': {
            color: theme.palette.text.primary,
            '&& $icon': {
                opacity: 1,
                color: theme.palette.text.secondary,
            },
        },
        '&$active': {
            color: theme.palette.text.primary,
            '&& $icon': {
                opacity: 1,
                color: theme.palette.text.secondary,
            },
        },
        '&$hovered': {
            color: theme.palette.text.secondary,
            '& $icon': {
                opacity: 0.5,
            },
        },
    },
    active: {},
    hovered: {},
    icon: {
        fontSize: 22,
        marginRight: 2,
        marginLeft: 2,
        opacity: 0,
        transition: theme.transitions.create(['opacity', 'transform'], {
            duration: theme.transitions.duration.shorter,
        }),
        userSelect: 'none',
    },
}); });
